<div class="min-h-screen grid grid-cols-1 lg:grid-cols-2">

  <!-- LEFT VISUAL SECTION -->
  <div
    class="hidden lg:flex flex-col justify-between bg-cover bg-center text-white p-20 relative"
    style="background-image: url('assets/img/bang.webp');"
  >
    <div class="absolute inset-0 bg-black/40"></div>

    <div class="relative z-10 max-w-lg">
      <h1 class="text-4xl font-bold leading-tight mb-6">
        Discover Bengaluru’s Finest Homes.
      </h1>
      <p class="text-lg opacity-90">
        Tell us what you’re looking for. Our advisors will curate properties that align with your lifestyle and expectations.
      </p>
    </div>

    <div class="relative z-10 text-sm opacity-80">
      Trusted by discerning buyers across Bengaluru.
    </div>
  </div>

  <!-- RIGHT FORM SECTION -->
  <div class="flex flex-col justify-center items-center bg-gradient-to-br from-[#faf7f5] to-[#f3efe9] p-8 lg:p-14 pt-32">

    <a routerLink="/" class="my-10">
      <img src="assets/img/logo.png" alt="Logo" class="w-32" />
    </a>

    <form
      [formGroup]="form"
      class="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-8 space-y-8 transition-all duration-300"
    >

      <!-- Header -->
      <div>
        <h2 class="text-2xl font-semibold mb-2">
          Let’s Find Your Ideal Home
        </h2>
        <p class="text-gray-500">
          Answer 5 quick questions. Our advisor will begin tailoring recommendations instantly.
        </p>
      </div>

      <!-- MICRO MARKETS -->
      <div class="relative dropdown-wrapper">
        <label class="font-medium mb-2 block">
          Preferred Locations
          <span class="text-xs text-gray-400">(Choose up to 3)</span>
        </label>

        <div
          (click)="toggleDropdown('market')"
          class="border border-gray-300 hover:border-black transition rounded-xl p-3 min-h-[52px] flex flex-wrap gap-2 items-center justify-between cursor-pointer focus-within:ring-2 focus-within:ring-black"
        >
          <div class="flex flex-wrap gap-2 flex-1">
            <ng-container *ngFor="let market of form.controls['microMarkets'].value">
              <div class="bg-black text-white px-3 py-1 rounded-full text-sm flex items-center gap-2">
                {{ market.micromarketName }}
                <button
                  type="button"
                  (click)="removeChip('microMarkets', market); $event.stopPropagation()"
                  class="text-xs opacity-80 hover:opacity-100"
                >
                  ✕
                </button>
              </div>
            </ng-container>

            <span
              *ngIf="form.controls['microMarkets'].value.length === 0"
              class="text-gray-400 text-sm"
            >
              Select locations you love
            </span>
          </div>

          <!-- Caret -->
          <svg
            class="w-4 h-4 text-gray-500 transition-transform duration-200"
            [ngClass]="{ 'rotate-180': isMarketOpen }"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 9l-7 7-7-7" />
          </svg>
        </div>

        <div
          *ngIf="isMarketOpen"
          class="absolute w-full bg-white border rounded-xl mt-2 shadow-xl z-50"
        >

          
          <div class="p-2 border-b sticky top-0 bg-white">
            <input
              #searchInput
              type="text"
              [value]="searchMarket"
              (input)="searchMarket = $any($event.target).value"
              (click)="$event.stopPropagation()"
              placeholder="Search locations..."
              class="w-full px-3 py-2 text-sm border rounded-lg focus:outline-none focus:ring-1 focus:ring-black"
            />
          </div>

          <!-- 📍 List -->
          <div class="max-h-52 overflow-y-auto">
            <div
              *ngFor="let market of filteredMarkets"
              (click)="selectOption('microMarkets', market, 3)"
              class="px-4 py-3 hover:bg-gray-100 cursor-pointer flex justify-between items-center"
            >
              <span>{{ market.micromarketName }}</span>

              <span
                *ngIf="form.controls['microMarkets'].value.includes(market)"
                class="text-green-600 font-medium"
              >
                ✓
              </span>
            </div>

            <!-- Empty state -->
            <div
              *ngIf="filteredMarkets.length === 0"
              class="px-4 py-6 text-sm text-gray-400 text-center"
            >
              No locations found
            </div>
          </div>
        </div>
      </div>

      <!-- APARTMENT TYPE -->
     <div class="relative dropdown-wrapper">
        <label class="font-medium mb-2 block">
            Community Preference
        </label>

        <div
            (click)="toggleDropdown('apartment')"
            class="border border-gray-300 hover:border-black transition rounded-xl p-3 min-h-[52px] flex flex-wrap gap-2 items-center justify-between cursor-pointer"
        >
            <div class="flex flex-wrap gap-2 flex-1">
            <ng-container *ngFor="let option of form.controls['apartmentType'].value">
                <div class="bg-black text-white px-3 py-1 rounded-full text-sm flex items-center gap-2">
                {{ option }}
                <button
                    type="button"
                    (click)="removeChip('apartmentType', option); $event.stopPropagation()"
                    class="text-xs"
                >
                    ✕
                </button>
                </div>
            </ng-container>

            <span
                *ngIf="form.controls['apartmentType'].value.length === 0"
                class="text-gray-400 text-sm"
            >
                Select your preferred community type
            </span>
            </div>

            <!-- Caret -->
            <svg
            class="w-4 h-4 text-gray-500 transition-transform duration-200"
            [ngClass]="{ 'rotate-180': isApartmentOpen }"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 9l-7 7-7-7" />
            </svg>
        </div>

        <div
            *ngIf="isApartmentOpen"
            class="absolute w-full bg-white border rounded-xl mt-2 shadow-xl max-h-60 overflow-y-auto z-50"
        >
            <div
            *ngFor="let option of apartmentPreference"
            (click)="selectOption('apartmentType', option,1)"
            class="px-4 py-3 hover:bg-gray-100 cursor-pointer flex justify-between items-center"
            >
            <span>{{ option }}</span>
            <span
                *ngIf="form.controls['apartmentType'].value.includes(option)"
                class="text-green-600 font-medium"
            >
                ✓
            </span>
            </div>
        </div>
    </div>

      <!-- BUDGET -->
      <div>
        <label class="font-medium mb-2 block">
          Ideal Budget Range
        </label>

        <select
          formControlName="budget"
          class="w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-black focus:border-black transition"
        >
          <option value="">Select budget range</option>
          <option *ngFor="let budget of budgetRanges" [value]="budget">
            {{ budget }}
          </option>
        </select>
      </div>

      <!-- CONFIGURATION -->
      <div>
        <label class="font-medium mb-2 block">
          Configuration Preference
        </label>

        <select
          formControlName="configuration"
          class="w-full border border-gray-300 rounded-xl p-3 focus:ring-2 focus:ring-black focus:border-black transition"
        >
          <option value="">Select configuration</option>
          <option *ngFor="let config of configurations" [value]="config">
            {{ config }}
          </option>
        </select>
      </div>

      <!-- COMPLETION -->
      <div class="relative dropdown-wrapper">
        <label class="font-medium mb-2 block">
          Project Status Preference
        </label>

        <div
          (click)="toggleDropdown('completion')"
          class="border border-gray-300 hover:border-black transition rounded-xl p-3 min-h-[52px] flex flex-wrap gap-2 items-center justify-between cursor-pointer"
        >
          <div class="flex flex-wrap gap-2 flex-1">
            <ng-container *ngFor="let option of form.controls['completion'].value">
              <div class="bg-black text-white px-3 py-1 rounded-full text-sm flex items-center gap-2">
                {{ option }}
                <button
                  type="button"
                  (click)="removeChip('completion', option); $event.stopPropagation()"
                  class="text-xs"
                >
                  ✕
                </button>
              </div>
            </ng-container>

            <span
              *ngIf="form.controls['completion'].value.length === 0"
              class="text-gray-400 text-sm"
            >
              Select preferred status
            </span>
          </div>

          <svg
            class="w-4 h-4 text-gray-500 transition-transform duration-200"
            [ngClass]="{ 'rotate-180': isCompletionOpen }"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M19 9l-7 7-7-7" />
          </svg>
        </div>
        <div
          *ngIf="isCompletionOpen"
          class="absolute w-full bg-white border rounded-xl mt-2 shadow-xl max-h-60 overflow-y-auto z-50"
        >
          <div
            *ngFor="let option of completionPreference"
            (click)="selectOption('completion', option)"
            class="px-4 py-3 hover:bg-gray-100 cursor-pointer flex justify-between"
          >
            <span>{{ option }}</span>
            <span
              *ngIf="form.controls['completion'].value.includes(option)"
              class="text-green-600"
            >
              ✓
            </span>
          </div>
        </div>
      </div>
      <!-- </div> -->
      <!-- <div class="absolute w-full bg-white border rounded-xl mt-2 shadow-xl max-h-60 overflow-y-auto z-50"> -->
      <div class="flex flex-col gap-1">
        <label class="font-medium mb-2 mt-1 block">Notes</label>
        <input
          type="text"
          formControlName="notes"
          placeholder="Enter your note..."
          class="px-4 py-3 w-full border border-gray-300 rounded-lg text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
      </div>

      <!-- CTA -->
      <button
        type="button"
        (click)="submit()"
        [disabled]="isSubmitting"
        class="w-full bg-black text-white py-4 rounded-xl font-medium hover:bg-gray-900 transition-all duration-200 disabled:opacity-50"
      >
        {{ isSubmitting ? 'Curating Homes...' : 'Find My Perfect Home' }}
      </button>

      <p class="text-xs text-gray-400 text-center">
        No spam. Just curated recommendations aligned with your preferences.
      </p>

    </form>
  </div>
</div>

<div *ngIf="showSuccessPopup" class="fixed inset-0 z-50 flex items-center justify-center">

  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"
       (click)="closePopup()"></div>

  <!-- Modal -->
  <div class="relative bg-white rounded-2xl shadow-2xl w-[90%] max-w-md p-6 text-center animate-[fadeInScale_0.3s_ease]">

    <!-- Success Icon -->
    <div class="flex justify-center mb-4">
      <div class="w-14 h-14 flex items-center justify-center rounded-full bg-green-100">
        <svg class="w-7 h-7 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-width="3" stroke-linecap="round" stroke-linejoin="round"
            d="M5 13l4 4L19 7" />
        </svg>
      </div>
    </div>

    <!-- Title -->
    <h2 class="text-lg font-semibold text-gray-800 mb-2">
      Thank You!
    </h2>

    <!-- Message -->
    <p class="text-sm text-gray-600 mb-6 leading-relaxed">
      Thank you for sharing your preferences. Our team will get back to you with suitable properties.
      Meanwhile, feel free to explore our listings.
    </p>

    <!-- Actions -->
    <div class="flex gap-3 justify-center">
      <!-- <button
        class="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
        (click)="closePopup()">
        Close
      </button> -->

      <button
        class="px-6 py-3 rounded-full bg-[#8b5cf6] text-white transition"
        (click)="goToListings()">
        Explore Listings
      </button>
    </div>

  </div>
</div>